const BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const resolveImageUrl = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  if (url.startsWith('/api/')) return `${BASE_URL}${url}`;
  return url;
};
